/**
 * Build a canonical datagrid_key shared by Personalize View,
 * Organization Datagrid Configuration, and list grids (TableDataGeneric).
 *
 * Accepts either a bare table name (`employees`) or a full key already
 * ending with `_grid_{orgId}` / `_{orgId}` (as MultiTableConfig may pass).
 *
 * @param {string|null|undefined} tableNameOrKey
 * @param {string|number|null|undefined} orgId
 * @returns {string|null}
 */
export function buildDatagridKey(tableNameOrKey, orgId) {
  if (tableNameOrKey == null || orgId == null || orgId === "") {
    return null;
  }

  const raw = String(tableNameOrKey).trim();
  if (!raw) return null;

  const id = String(orgId);
  const gridSuffix = `_grid_${id}`;
  const idSuffix = `_${id}`;

  // Full key already: Employees_grid_5 or organization_holiday_calendars_5
  if (raw.endsWith(gridSuffix) || raw.endsWith(idSuffix)) {
    return raw;
  }

  // Bare table / display name → canonical `{name}_grid_{orgId}`
  return `${raw}_grid_${id}`;
}
